import {
  Avatar,
  Button,
  Card,
  Descriptions,
  Form,
  Input,
  message,
  Modal,
  Skeleton,
  Typography,
} from 'antd';
import React, { useContext } from 'react';
import { AiOutlineUser } from 'react-icons/ai';
import ThemeContext from 'store/ThemeContext';
import styled from 'styled-components';
import { changePasswordFor773, getCustomRedirect, getSessionUser } from '../../../services/auth';
import locales from '../../../locales';

const StyledCard = styled(Card)`
  border-radius: 8px;
  background-color: #eaf0f7;
  .ant-card-body {
    padding: 40px;
  }
  .ant-descriptions-row:last-child > th,
  .ant-descriptions-row:last-child > td {
    padding-bottom: 0px;
  }
`;
const styles = {
  avata: {
    color: '#94a2f4',
    backgroundColor: '#5b69bc',
    size: 40,
  },
  form: {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  },
};

/**
 * 사용자 정보 표시
 * @returns ReactNode
 */
function UserInfo() {
  const [changePasswordVisible, setChangePasswordVisible] = React.useState(false);
  const [user, setUser] = React.useState(undefined);
  const [customUrls, setCustomUrls] = React.useState();
  const [passwordResetForm] = Form.useForm();
  const theme = useContext(ThemeContext);

  React.useEffect(() => {
    getSessionUser().then((res) => {
      setUser(res.data);
    });
    getCustomRedirect().then((customUrl) => setCustomUrls(customUrl));
  }, []);

  const onOK = async () => {
    const userId = localStorage.getItem('userId');
    const password = passwordResetForm.getFieldValue('newPwd2');
    const res = await changePasswordFor773(userId, password);
    if (res.type === 'error') {
      message.error(res.message);
      passwordResetForm.resetFields();
    } else {
      message.success(res.message);
      setChangePasswordVisible(false);
    }
  };

  return (
    <StyledCard bordered={false}>
      <Skeleton loading={user === undefined} avatar active>
        <Card.Meta
          avatar={<Avatar style={styles.avata} size={40} icon={<AiOutlineUser />} />}
          title={user && <Typography.Title level={4}>{user.name}</Typography.Title>}
          description={
            user && (
              <Descriptions size="small" column={2}>
                <Descriptions.Item label={locales['front.login.id']}>
                  {user.sAMAccountName}
                </Descriptions.Item>
                <Descriptions.Item label="부서">{user.organization}</Descriptions.Item>
                <Descriptions.Item label="이메일">{user.mail}</Descriptions.Item>
                {theme.customUrls?.passwordChange && (
                  <Descriptions.Item label="비밀번호">
                    <Button
                      size="small"
                      onClick={
                        theme.customUrls?.passwordChange !== 'default'
                          ? () => {
                              window.open(
                                customUrls?.passwordChange,
                                '',
                                `${
                                  theme.customUrls?.passwordChange?.windowFeatures !== undefined
                                    ? theme.customUrls.passwordChange.windowFeatures
                                    : `height=${window.screen.height},width=${window.screen.width},resizable=yes,fullscreen=yes`
                                }`,
                              );
                            }
                          : () => {
                              setChangePasswordVisible(true);
                            }
                      }
                    >
                      변경하기
                    </Button>
                    <Modal
                      title="비밀번호 변경"
                      visible={changePasswordVisible}
                      width={380}
                      okText="변경"
                      cancelText="취소"
                      onOk={onOK}
                      onCancel={() => {
                        setChangePasswordVisible(false);
                        passwordResetForm.resetFields();
                      }}
                    >
                      <Form
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        form={passwordResetForm}
                      >
                        <Form.Item
                          label="신규 비밀번호"
                          name="newPwd1"
                          rules={[{ required: true, message: '비밀번호를 입력하십시오.' }]}
                        >
                          <Input.Password visibilityToggle={false} allowClear />
                        </Form.Item>
                        <Form.Item
                          label="비밀번호 확인"
                          name="newPwd2"
                          dependencies={['newPwd1']}
                          hasFeedback
                          rules={[
                            { required: true, message: '비밀번호를 입력하십시오.' },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (!value || getFieldValue('newPwd1') === value) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(
                                  new Error('입력된 비밀번호가 일치하지 않습니다.'),
                                );
                              },
                            }),
                          ]}
                        >
                          <Input.Password visibilityToggle={false} allowClear />
                        </Form.Item>
                      </Form>
                    </Modal>
                  </Descriptions.Item>
                )}
              </Descriptions>
            )
          }
        />
      </Skeleton>
    </StyledCard>
  );
}

export default UserInfo;
